/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Room_ExampleInputs */

const en_mk_room_example = /** @type {(inputs: Mk_Room_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore a six-step Design Room example`)
};

const id_mk_room_example = /** @type {(inputs: Mk_Room_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat contoh ruang diskusi enam langkah`)
};

/**
* | output |
* | --- |
* | "Explore a six-step Design Room example" |
*
* @param {Mk_Room_ExampleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_room_example = /** @type {((inputs?: Mk_Room_ExampleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Room_ExampleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_room_example(inputs)
	return en_mk_room_example(inputs)
});